import {
  DOMAIN_CREATE, DOMAIN_SAVE_FAILURE, DOMAIN_SAVE_SUCCESS
} from './mutation-types'

export default {
  state: {
    domains: []
  },
  getters: {
    domains: state => {
      return state.domains
    }
  },
  actions: {
    [DOMAIN_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/domains', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(DOMAIN_SAVE_FAILURE, res.data)
            } else {
              commit(DOMAIN_SAVE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [DOMAIN_SAVE_FAILURE] (state, data) {
      console.log('DOMAIN_SAVE_FAILURE')
    },
    [DOMAIN_SAVE_SUCCESS] (state, data) {
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/domain-new.js